import React from 'react';

export default function ScheduleHero({ scheduleData }) {
    if (!scheduleData) return null;
    const { page } = scheduleData;
    return (
        <section className="sch-hero">
            <style>{`
                .sch-hero {
                    position: relative;
                    padding: 160px 0 90px;
                    background: var(--eventflow-black);
                    overflow: hidden;
                    text-align: center;
                }
                .sch-hero::before {
                    content: '';
                    position: absolute; inset: 0;
                    background:
                        radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-primary-rgb),0.2) 0%, transparent 60%),
                        radial-gradient(ellipse at 80% 90%, rgba(var(--eventflow-base-rgb),0.1) 0%, transparent 50%);
                    pointer-events: none;
                }
                .sch-hero::after {
                    content: '';
                    position: absolute; inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                }
                .sch-hero__inner { position: relative; z-index: 2; }
                .sch-hero__tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 20px;
                }
                .sch-hero__tag::before, .sch-hero__tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .sch-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 68px; font-weight: 900;
                    color: #fff; line-height: 1.0;
                    letter-spacing: -2px; margin-bottom: 18px;
                }
                .sch-hero__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .sch-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 16px; color: rgba(255,255,255,0.5);
                    max-width: 560px; margin: 0 auto 36px; line-height: 1.75;
                }
                .sch-hero__meta {
                    display: flex; justify-content: center;
                    gap: 12px; flex-wrap: wrap;
                }
                .sch-hero__meta-item {
                    display: inline-flex; align-items: center; gap: 8px;
                    background: rgba(255,255,255,0.04);
                    border: 1px solid rgba(255,255,255,0.08);
                    border-radius: 50px; padding: 9px 20px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.6);
                }
                .sch-hero__meta-item i { color: var(--eventflow-base); font-size: 12px; }
                @media (max-width: 768px) {
                    .sch-hero { padding: 130px 0 60px; }
                    .sch-hero__title { font-size: 42px; letter-spacing: -1px; }
                }
            `}</style>
            <div className="container">
                <div className="sch-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="sch-hero__tag">{page.eyebrow}</div>
                    <h1 className="sch-hero__title">
                        {page.title} <span>{page.titleAccent}</span>
                    </h1>
                    <p className="sch-hero__sub">{page.subtitle}</p>
                    <div className="sch-hero__meta">
                        <span className="sch-hero__meta-item"><i className="fa fa-calendar-alt" />{page.eventDate}</span>
                        <span className="sch-hero__meta-item"><i className="fa fa-map-marker-alt" />{page.eventVenue}</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
